"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPSInfoTextToJSON = exports.UPSInfoTextFromJSONTyped = exports.UPSInfoTextFromJSON = exports.instanceOfUPSInfoText = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UPSInfoText interface.
 */
function instanceOfUPSInfoText(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUPSInfoText = instanceOfUPSInfoText;
function UPSInfoTextFromJSON(json) {
    return UPSInfoTextFromJSONTyped(json, false);
}
exports.UPSInfoTextFromJSON = UPSInfoTextFromJSON;
function UPSInfoTextFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'text': !(0, runtime_1.exists)(json, 'text') ? undefined : json['text'],
        'icon': !(0, runtime_1.exists)(json, 'icon') ? undefined : json['icon'],
    };
}
exports.UPSInfoTextFromJSONTyped = UPSInfoTextFromJSONTyped;
function UPSInfoTextToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text': value.text,
        'icon': value.icon,
    };
}
exports.UPSInfoTextToJSON = UPSInfoTextToJSON;
